import {
  FETCH_MUSIC_LINKS_LIST,
  FETCH_MUSIC_LINKS_LIST_ERROR,
  CLEAR_MUSIC_LINKS_LIST,
  ADD_MUSIC_LINK_SUCCESS,
  ADD_MUSIC_LINK_ERROR,
  CLEAR_MUSIC_LINK_STATUS,
  PATCH_MUSIC_LINK_SUCCESS,
  PATCH_MUSIC_LINK_ERROR,
  CLEAR_MUSIC_LINK_PATCH_STATUS,
  DELETE_MUSIC_LINK_SUCCESS,
  DELETE_MUSIC_LINK_ERROR,
  CLEAR_MUSIC_LINK_DELETE_STATUS,
  APPLY_MUSIC_LINK_DRAG,
  APPLY_MUSIC_LINK_DRAG_ERROR,
  CLEAR_MUSIC_LINK_DRAG,
  FETCH_MUSIC_LINK_DETAILS,
  FETCH_MUSIC_LINK_DETAILS_ERROR,
  CLEAR_MUSIC_LINK_DETAILS,
  PATCH_MUSIC_MEDIA_SAMPLE_SUCCESS,
  PATCH_MUSIC_MEDIA_SAMPLE_ERROR,
  CLEAR_MUSIC_MEDIA_SAMPLE_PATCH_STATUS,
  UPDATE_MUSIC_LINK_SOURCE_SUCCESS,
  UPDATE_MUSIC_LINK_SOURCE_ERROR,
  CLEAR_MUSIC_LINK_UPDATE_SOURCE_STATUS,
  ADD_MUSIC_SERVICE_LINK_SUCCESS,
  ADD_MUSIC_SERVICE_LINK_ERROR,
  CLEAR_ADD_MUSIC_SERVICE_LINK,
  PATCH_MUSIC_SERVICE_LINK_SUCCESS,
  PATCH_MUSIC_SERVICE_LINK_ERROR,
  CLEAR_PATCH_MUSIC_SERVICE_LINK,
  DELETE_MUSIC_SERVICE_LINK_SUCCESS,
  DELETE_MUSIC_SERVICE_LINK_ERROR,
  CLEAR_DELETE_MUSIC_SERVICE_LINK,
} from 'redux/music-links/types';

const initialState = {
  musicLinksList: null,
  musicLinksListError: null,
  addMusicLinkSuccess: null,
  addMusicLinkError: null,
  patchMusicLinkSuccess: null,
  patchMusicLinkError: null,
  patchMediaSampleSuccess: null,
  patchMediaSampleError: null,
  updateMusicLinkSourceSuccess: null,
  updateMusicLinkSourceError: null,
  deleteMusicLinkSuccess: null,
  deleteMusicLinkError: null,
  musiclinkDragSuccess: null,
  musiclinkDragError: null,
  musicLinkDetails: null,
  musicLinkDetailsError: null,
  addMusicServiceLinkSuccess: null,
  addMusicServiceLinkError: null,
  patchMusicServiceLinkSuccess: null,
  patchMusicServiceLinkError: null,
  deleteMusicServiceLinkSuccess: null,
  deleteMusicServiceLinkError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_MUSIC_LINK_SUCCESS:
      return {
        ...state,
        addMusicLinkSuccess: action.payload.data,
        addMusicLinkError: null,
      };
    case ADD_MUSIC_LINK_ERROR:
      return {
        ...state,
        addMusicLinkSuccess: null,
        addMusicLinkError: action.payload.data,
      };
    case CLEAR_MUSIC_LINK_STATUS:
      return {
        ...state,
        addMusicLinkSuccess: null,
        addMusicLinkError: null,
      };
    case FETCH_MUSIC_LINKS_LIST:
      return {
        ...state,
        musicLinksList: action.payload.data,
        musicLinksListError: null,
      };
    case FETCH_MUSIC_LINKS_LIST_ERROR:
      return {
        ...state,
        musicLinksList: null,
        musicLinksListError: action.payload.data,
      };
    case CLEAR_MUSIC_LINKS_LIST:
      return {
        ...state,
        musicLinksList: null,
        musicLinksListError: null,
      };
    case PATCH_MUSIC_LINK_SUCCESS:
      return {
        ...state,
        patchMusicLinkSuccess: action.payload.data,
        patchMusicLinkError: null,
      };
    case PATCH_MUSIC_LINK_ERROR:
      return {
        ...state,
        patchMusicLinkSuccess: null,
        patchMusicLinkError: action.payload.data,
      };
    case CLEAR_MUSIC_LINK_PATCH_STATUS:
      return {
        ...state,
        patchMusicLinkSuccess: null,
        patchMusicLinkError: null,
      };
    case PATCH_MUSIC_MEDIA_SAMPLE_SUCCESS:
      return {
        ...state,
        patchMediaSampleSuccess: action.payload.data,
        patchMediaSampleError: null,
      };
    case PATCH_MUSIC_MEDIA_SAMPLE_ERROR:
      return {
        ...state,
        patchMediaSampleSuccess: null,
        patchMediaSampleError: action.payload.data,
      };
    case CLEAR_MUSIC_MEDIA_SAMPLE_PATCH_STATUS:
      return {
        ...state,
        patchMediaSampleSuccess: null,
        patchMediaSampleError: null,
      };
    case UPDATE_MUSIC_LINK_SOURCE_SUCCESS:
      return {
        ...state,
        updateMusicLinkSourceSuccess: action.payload.data,
        updateMusicLinkSourceError: null,
      };
    case UPDATE_MUSIC_LINK_SOURCE_ERROR:
      return {
        ...state,
        updateMusicLinkSourceSuccess: null,
        updateMusicLinkSourceError: action.payload.data,
      };
    case CLEAR_MUSIC_LINK_UPDATE_SOURCE_STATUS:
      return {
        ...state,
        updateMusicLinkSourceSuccess: null,
        updateMusicLinkSourceError: null,
      };
    case DELETE_MUSIC_LINK_SUCCESS:
      return {
        ...state,
        deleteMusicLinkSuccess: action.payload.data,
        deleteMusicLinkError: null,
      };
    case DELETE_MUSIC_LINK_ERROR:
      return {
        ...state,
        deleteMusicLinkSuccess: null,
        deleteMusicLinkError: action.payload.data,
      };
    case CLEAR_MUSIC_LINK_DELETE_STATUS:
      return {
        ...state,
        deleteMusicLinkSuccess: null,
        deleteMusicLinkError: null,
      };
    case APPLY_MUSIC_LINK_DRAG:
      return {
        ...state,
        musiclinkDragSuccess: action.payload.data === '' ? true : null,
        musiclinkDragError: null,
      };
    case APPLY_MUSIC_LINK_DRAG_ERROR:
      return {
        ...state,
        musiclinkDragSuccess: null,
        musiclinkDragError: action.payload.data === '' ? true : null,
      };
    case CLEAR_MUSIC_LINK_DRAG:
      return {
        ...state,
        musiclinkDragSuccess: null,
        musiclinkDragError: null,
      };
    case FETCH_MUSIC_LINK_DETAILS:
      return {
        ...state,
        musicLinkDetails: action.payload.data,
        musicLinkDetailsError: null,
      };
    case FETCH_MUSIC_LINK_DETAILS_ERROR:
      return {
        ...state,
        musicLinkDetails: null,
        musicLinkDetailsError: action.payload.data,
      };
    case CLEAR_MUSIC_LINK_DETAILS:
      return {
        ...state,
        musicLinkDetails: null,
        musicLinkDetailsError: null,
      };
    case ADD_MUSIC_SERVICE_LINK_SUCCESS:
      return {
        ...state,
        addMusicServiceLinkSuccess: action.payload.data,
        addMusicServiceLinkError: null,
      };
    case ADD_MUSIC_SERVICE_LINK_ERROR:
      return {
        ...state,
        addMusicServiceLinkSuccess: null,
        addMusicServiceLinkError: action.payload.data,
      };
    case CLEAR_ADD_MUSIC_SERVICE_LINK:
      return {
        ...state,
        addMusicServiceLinkSuccess: null,
        addMusicServiceLinkError: null,
      };
    case PATCH_MUSIC_SERVICE_LINK_SUCCESS:
      return {
        ...state,
        patchMusicServiceLinkSuccess: action.payload.data,
        patchMusicServiceLinkError: null,
      };
    case PATCH_MUSIC_SERVICE_LINK_ERROR:
      return {
        ...state,
        patchMusicServiceLinkSuccess: null,
        patchMusicServiceLinkError: action.payload.data,
      };
    case CLEAR_PATCH_MUSIC_SERVICE_LINK:
      return {
        ...state,
        patchMusicServiceLinkSuccess: null,
        patchMusicServiceLinkError: null,
      };
    case DELETE_MUSIC_SERVICE_LINK_SUCCESS:
      return {
        ...state,
        deleteMusicServiceLinkSuccess: action.payload.data,
        deleteMusicServiceLinkError: null,
      };
    case DELETE_MUSIC_SERVICE_LINK_ERROR:
      return {
        ...state,
        deleteMusicServiceLinkSuccess: null,
        deleteMusicServiceLinkError: action.payload.data,
      };
    case CLEAR_DELETE_MUSIC_SERVICE_LINK:
      return {
        ...state,
        deleteMusicServiceLinkSuccess: null,
        deleteMusicServiceLinkError: null,
      };
    default:
      return state;
  }
};
